import {Injectable} from '@angular/core';
import {CommonService} from './common.service';
import {EvaluationService} from './evaluation.service';


@Injectable({
  providedIn: 'root'
})
export class UsedBudgetService {
  budget: any;
  materials: any;
  regionals: any;
  inspectors: any;
  salesGroups: any;
  categories: any;

  constructor(private commonService: CommonService,
              private evaluationService: EvaluationService) {
  }

  async fetchUploadedBudgetFiles() {
    return await this.commonService.getSimpleList(`used_budget/file`);
  }

  async fetchUploadedBudgetFilesInfo(id: number) {
    return await this.commonService.getSimpleList(`used_budget/${id}`);
  }

  async setFileActivityStatus(id: number, status: number) {
    return await this.commonService.updateObject(`used_budget/file/${id}`, {isActive: status ? 1 : 0});
  }

  async fetchMaterials() {
    if (!this.materials) {
      this.materials = await this.commonService.getSimpleList('material');
    }

    return this.materials;
  }

  async fetchSalesGroups() {
    if (!this.salesGroups) {
      this.salesGroups = await this.commonService.getSimpleList('sales_group?order=name asc');
    }

    return this.salesGroups;
  }


  async fetchInspectors() {
    if (!this.inspectors) {
      this.inspectors = await this.commonService.getSimpleList('user?filter=role_id=4&order=name asc');
    //  this.inspectors.unshift({id: 0, name: 'ΟΛΟΙ'});

    }

    return this.inspectors;
  }

  async fetchCategories() {
    if (!this.categories) {
      this.categories = await this.commonService.getSimpleList('evaluation/categories');
    //  this.categories.unshift({id: 0, name: 'ΟΛΕΣ'});
    }

    return this.categories;
  }

  async fetchRegionals() {
    if (!this.regionals) {
      this.regionals = await this.commonService.getSimpleList('user/regionals');
     // this.regionals.unshift({id: 0, name: 'ΟΛΕΣ'});
    }

    return this.regionals;
  }

  async fetchBudget(force?: boolean) {
    if (!this.budget || force) {
      this.budget = await this.commonService.getList(`used_budget`);
      let id = 1;
      this.budget.forEach(row => {
        row.id = id;
        row['new-redistribution'] = '';
        id++;
      });
    }
    return this.budget;
  }

  async updateRedistribution(object) {
    return await this.commonService.updateObject(`used_budget/redistribution`, object);
  }

  async insertUserBudget(object) {
    return await this.commonService.insertObject(`used_budget`, object);
  }
}
